/* [BD feat] Collection variant filter — client-side, no URL; updates card content on filter change */
if (!customElements.get('bd-collection-filter')) {
  class BdCollectionFilter extends HTMLElement {
    connectedCallback() {
      const firstLabel = this.dataset.firstLabel || '';
      const filterBtns = this.querySelectorAll('.bd-collection-filter__item[data-bd-filter-label]');
      const productGrid = document.getElementById('product-grid');

      if (!productGrid) return;

      const items = productGrid.querySelectorAll('.bd-collection-filter-item[data-bd-filter-labels]');
      const emptyEl = productGrid.querySelector('#bd-collection-filter-empty');
      const iconTemplate = document.getElementById('bd-collection-feature-icons');
      const labelDividerTemplate = document.getElementById('bd-collection-feature-label-divider');

      const normalize = (s) => (s || '').toString().trim().toLowerCase();

      const updateCardContent = (cardWrapper, variantData) => {
        if (!variantData) return;
        const link = cardWrapper.querySelector('.bd-collection-card__link');
        const img = cardWrapper.querySelector('.bd-collection-card__image');
        const priceTag = cardWrapper.querySelector('.bd-collection-card__price-tag-text');
        const description = cardWrapper.querySelector('.bd-collection-card__description');
        const featuresList = cardWrapper.querySelector('.bd-collection-card__features');
        const infoDiv = cardWrapper.querySelector('.bd-collection-card__info');

        if (link && variantData.url) link.href = variantData.url;
        if (priceTag && variantData.price) priceTag.textContent = variantData.price;
        /* [BD feat] Mix box — sync compare when sale-row is in DOM (Liquid chose sale branch) */
        const compareEl = cardWrapper.querySelector('.bd-collection-card__price-tag-compare');
        const cmp = variantData.compare_at_price;
        if (compareEl) {
          if (cmp) {
            compareEl.textContent = cmp;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
            compareEl.textContent = '';
          }
        }

        const mediaContainer = cardWrapper.querySelector('.bd-collection-card__media');
        if (mediaContainer) {
          if (variantData.image) {
            let imgEl = mediaContainer.querySelector('.bd-collection-card__image');
            const placeholder = mediaContainer.querySelector('.bd-collection-card__placeholder');
            if (placeholder) placeholder.style.display = 'none';
            if (!imgEl) {
              imgEl = document.createElement('img');
              imgEl.className = 'bd-collection-card__image';
              imgEl.loading = 'lazy';
              imgEl.sizes = '(min-width: 992px) calc((100vw - 130px) / 4), (min-width: 768px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';
              mediaContainer.appendChild(imgEl);
            }
            imgEl.style.display = '';
            imgEl.src = variantData.image;
            if (variantData.srcset) imgEl.srcset = variantData.srcset;
            if (variantData.width) imgEl.width = variantData.width;
            if (variantData.height) imgEl.height = variantData.height;
            if (variantData.alt != null) imgEl.alt = variantData.alt;
          } else {
            const imgEl = mediaContainer.querySelector('.bd-collection-card__image');
            const placeholder = mediaContainer.querySelector('.bd-collection-card__placeholder');
            if (imgEl) imgEl.style.display = 'none';
            if (placeholder) placeholder.style.display = '';
          }
        }

        if (description) {
          if (variantData.tagline) {
            description.textContent = variantData.tagline;
            description.style.display = '';
          } else {
            description.style.display = 'none';
          }
        }

        /* [BD feat] product_card_details background_color & text_color on variant switch */
        if (infoDiv) {
          const toStr = (v) => (typeof v === 'string' ? v : (v && typeof v === 'object' && v.red != null ? `rgb(${v.red},${v.green},${v.blue})` : ''));
          const bg = variantData.background_color;
          const txt = variantData.text_color;
          if (bg) infoDiv.style.setProperty('--bd-info-bg', toStr(bg));
          else infoDiv.style.removeProperty('--bd-info-bg');
          if (txt) infoDiv.style.setProperty('--bd-info-color', toStr(txt));
          else infoDiv.style.removeProperty('--bd-info-color');
        }

        if (featuresList && iconTemplate) {
          const cloneIcon = (type) => {
            const el = iconTemplate.content.querySelector(`[data-icon-type="${type}"]`);
            return el ? el.cloneNode(true) : null;
          };

          const buildSplitFeatureContent = (parts, iconType) => {
            const fragment = document.createDocumentFragment();
            parts.forEach((text, i) => {
              if (i > 0 && labelDividerTemplate?.content.firstElementChild) {
                fragment.appendChild(labelDividerTemplate.content.firstElementChild.cloneNode(true));
              }
              const part = document.createElement('div');
              part.className = 'bd-collection-card__feature-part';
              const icon = cloneIcon(iconType);
              if (icon) part.appendChild(icon);
              const textSpan = document.createElement('span');
              textSpan.className = 'bd-collection-card__feature-text';
              textSpan.textContent = text;
              part.appendChild(textSpan);
              fragment.appendChild(part);
            });
            return fragment;
          };

          const features = [];
          if (variantData.suitability) {
            features.push({ iconType: 'checkmark', parts: [variantData.suitability] });
          }
          const vegFruitParts = [variantData.vegetable, variantData.fruit].filter(Boolean);
          if (vegFruitParts.length) {
            features.push({ iconType: 'dropbox', parts: vegFruitParts });
          }
          const servingWeightParts = [variantData.serving, variantData.weight].filter(Boolean);
          if (servingWeightParts.length) {
            features.push({ iconType: 'silhouette', parts: servingWeightParts });
          }

          featuresList.style.display = features.length ? '' : 'none';
          if (!features.length) return;

          const featureEls = featuresList.querySelectorAll('.bd-collection-card__feature');
          const dividerEls = featuresList.querySelectorAll('.bd-collection-card__features-divider');

          features.forEach((f, i) => {
            const el = featureEls[i];
            if (!el) return;
            el.replaceChildren();
            el.className = f.parts.length > 1
              ? 'bd-collection-card__feature bd-collection-card__feature--split'
              : 'bd-collection-card__feature';
            if (f.parts.length > 1) {
              el.appendChild(buildSplitFeatureContent(f.parts, f.iconType));
            } else {
              const icon = cloneIcon(f.iconType);
              if (icon) el.appendChild(icon);
              const label = document.createElement('span');
              label.className = 'bd-collection-card__feature-label';
              label.textContent = f.parts[0];
              el.appendChild(label);
            }
            el.hidden = false;
          });

          featureEls.forEach((el, i) => {
            el.hidden = i >= features.length;
          });

          dividerEls.forEach((el, i) => {
            if (features.length === 0) {
              el.hidden = true;
            } else if (i === dividerEls.length - 1) {
              el.hidden = false;
            } else {
              el.hidden = i >= features.length;
            }
          });
        }
      };

      const showFilter = (label, updateContent = true) => {
        const labelNorm = normalize(label);
        let visibleCount = 0;

        items.forEach((el) => {
          const labelsStr = el.dataset.bdFilterLabels || '';
          const labels = labelsStr.split(',').map((l) => normalize(l)).filter(Boolean);
          const hasVariantForFilter = labels.includes(labelNorm);
          el.classList.toggle('bd-collection-filter-item--hidden', !hasVariantForFilter);

          if (hasVariantForFilter) {
            visibleCount++;
            const variantsJson = el.dataset.bdVariants;
            if (variantsJson) {
              try {
                const variants = JSON.parse(variantsJson);
                const variantData = variants[labelNorm];
                if (variantData && updateContent) updateCardContent(el, variantData);
              } catch (_) { }
            }
          }
        });

        if (emptyEl) {
          emptyEl.classList.toggle('bd-collection-filter-item--hidden', visibleCount > 0);
          emptyEl.setAttribute('aria-hidden', visibleCount > 0 ? 'true' : 'false');
        }

        filterBtns.forEach((btn) => {
          const isActive = normalize(btn.dataset.bdFilterLabel) === labelNorm;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-current', isActive ? 'true' : 'false');
          const circleClass = 'bd-collection-filter__circle';
          const circle = btn.querySelector(`.${circleClass}`);
          if (circle) circle.classList.toggle('is-active', isActive);
        });
      };

      filterBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const label = btn.dataset.bdFilterLabel;
          if (label) showFilter(label);
        });
      });

      showFilter(firstLabel, false);
    }
  }
  customElements.define('bd-collection-filter', BdCollectionFilter);
}
/* [BD feat] Collection variant filter — end */
